import { render, staticRenderFns } from "./ClientAddDialog.vue?vue&type=template&id=887a8118"
import script from "./ClientAddDialog.vue?vue&type=script&lang=js"
export * from "./ClientAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports